import React from 'react';
import TranslatedCopy from '../../intl/translated-copy';

function TokenInvalidSecurityCard() {
  return (
    <div className='TokenInvalidSecurityCard'>
      <span className='TokenInvalidSecurityCard-icon Icon Icon--lockAndClock' />
      <TranslatedCopy
        className='TokenInvalidSecurityCard-message'
        copyID='PROFILE_AMR_LOGOUTSESSION_TOUCHPOINT'
        tagName='p'
      />
    </div>
  );
}

export default TokenInvalidSecurityCard;

